module.exports = __webpack_public_path__ + "img/2.f2463398.jpg";